<div class="form-field photo-field flex flex-column gap-3">
  @if (props['label']) {
  <label [for]="id" class="form-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }

  @if (error()) {
  <div class="photo-error">{{ error() }}</div>
  }

  <!-- Hidden file input — triggered programmatically by the Upload buttons -->
  <input type="file" [id]="id + '-file-input'" accept="image/*" [attr.multiple]="allowMultiple() ? '' : null"
    class="hidden-file-input" (change)="handleFileInput($event)" data-testid="file-upload-input" />

  @if (photoDataUrls().length === 0) {
  <!-- No photo yet — show both entry-point buttons -->
  <div class="photo-action-buttons">
    <app-button variant="outlined" (click)="openCameraDialog()" data-testid="start-camera-btn">
      <app-icon name="camera" />
      Take Photo
    </app-button>
    <app-button variant="outlined" (click)="triggerUpload()" data-testid="upload-photo-btn">
      <app-icon name="image" />
      Upload Photo
    </app-button>
  </div>
  }

  @if (photoDataUrls().length > 0) {
  <!-- Photo previews -->
  <div class="photo-previews-container">
    @for (photoUrl of photoDataUrls(); track $index) {
    <div class="photo-preview">
      <img [src]="photoUrl" alt="Captured photo {{ $index + 1 }}" class="photo-preview-img"
        [attr.data-testid]="'photo-preview-' + $index" />
      <div class="photo-preview-controls">
        <app-button variant="outlined" size="sm" (click)="downloadPhoto(photoUrl, $index)"
          [attr.data-testid]="'download-photo-btn-' + $index">
          <app-icon [size]="16" name="download" />
          Download
        </app-button>
        <app-button variant="outlined" size="sm" (click)="retakePhoto($index)"
          [attr.data-testid]="'retake-photo-btn-' + $index">
          <app-icon [size]="16" name="rotate-ccw" />
          Retake
        </app-button>
        <app-button variant="outlined" color="danger" size="sm" (click)="removePhoto($index)"
          [attr.data-testid]="'remove-photo-btn-' + $index">
          <app-icon [size]="16" name="trash-2" />
          Remove
        </app-button>
      </div>
    </div>
    }

    <!-- Add-more row (only if multiple photos allowed) -->
    @if (allowMultiple()) {
    <div class="photo-action-buttons">
      <app-button variant="outlined" (click)="openCameraDialog()" data-testid="add-another-photo-btn">
        <app-icon name="camera" />
        Take Photo
      </app-button>
      <app-button variant="outlined" (click)="triggerUpload()" data-testid="add-upload-photo-btn">
        <app-icon name="image" />
        Upload Photo
      </app-button>
    </div>
    }
  </div>
  }

  @if (props['description']) {
  <div class="form-description">{{ props['description'] }}</div>
  }

  <!-- Photo capture dialog (controlled by URL param) -->
  @if (showCameraDialog()) {
  <app-modal-dialog class="photo-capture-modal" (backdropClick)="closeCameraDialog()">
    <div content class="photo-video-wrapper">
      @if (error()) {
      <div class="photo-error" data-testid="camera-error">{{ error() }}</div>
      }

      <div class="video-container" [id]="id + '-video-container'" (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)" (pointerup)="onPointerUp($event)"
        (pointercancel)="onPointerCancel($event)" data-testid="video-container">
        <video [id]="id + '-video'" class="photo-video" autoplay playsinline
          [style.transform]="'scale(' + zoomLevel() + ')'" (click)="onVideoTap()" data-testid="camera-video">
        </video>

        <div class="camera-top-overlay">
          <div class="modal-title text-lg font-bold">Capture Photo</div>
          @if (props['captureInstructions']) {
          <div class="modal-instructions">{{ props['captureInstructions'] }}</div>
          }
        </div>

        <div class="zoom-overlay" data-testid="zoom-overlay">
          <span class="zoom-label" data-testid="zoom-label">{{ zoomLabel() }}</span>
          @if (zoomLevel() > 1) {
          <button class="zoom-reset-btn" type="button" (click)="resetZoom()" data-testid="zoom-reset-btn">
            Reset
          </button>
          }
        </div>

        <div class="camera-action-overlay">
          <app-button class="camera-cancel-btn" variant="outlined" (click)="closeCameraDialog()"
            data-testid="cancel-camera-btn">
            <app-icon name="x" />
            Cancel
          </app-button>
          <app-button variant="filled" (click)="capturePhoto()" [disabled]="!isCameraActive()"
            data-testid="capture-photo-btn">
            <app-icon name="circle" />
            Capture
          </app-button>
        </div>
      </div>
    </div>
  </app-modal-dialog>
  }
</div>